import { createReducer, on } from '@ngrx/store'
import { DisplayLayoutEnum } from '../../models/enums/display-layout.enum'
import * as WithClientsActions from './with-clients.actions'
import { LinkingWithClientsState } from './with-clients.state'

export const initialState: LinkingWithClientsState = {
   displayLayout: DisplayLayoutEnum.LIST,
}

export const withClientsReducer = createReducer(
   initialState,

   on(WithClientsActions.setWithClientsDisplayLayoutList, (state) => ({
      ...state,
      displayLayout: DisplayLayoutEnum.LIST,
   })),
   on(WithClientsActions.setWithClientsDisplayLayoutGrid, (state) => ({
      ...state,
      displayLayout: DisplayLayoutEnum.GRID,
   })),

   on(WithClientsActions.setWithClientsSearchFields, (state, action) => ({
      ...state,
      searchFields: action.searchFields,
      withClientsDetail: undefined,
   })),
   on(WithClientsActions.getWithClientsData, (state) => ({
      ...state,
      data: undefined,
      isLoading: true,
   })),
   on(WithClientsActions.getWithClientsDataSuccess, (state, action) => ({
      ...state,
      data: action.data,
      isLoading: false,
      needReload: false,
   })),
   on(WithClientsActions.getWithClientsDataFailure, (state) => ({
      ...state,
      data: undefined,
      isLoading: false,
      needReload: false,
   })),

   on(WithClientsActions.markWithClientsDataAsProcessed, WithClientsActions.deleteWithClientsData, (state) => ({
      ...state,
      needReload: false,
      isLoading: true,
   })),

   on(WithClientsActions.markWithClientsDataAsProcessedSuccess, WithClientsActions.deleteWithClientsDataSuccess, (state) => ({
      ...state,
      needReload: true,
   })),

   on(WithClientsActions.markWithClientsDataAsProcessedFailure, WithClientsActions.deleteWithClientsDataFailure, (state) => ({
      ...state,
      needReload: false,
      isLoading: false,
   })),
   on(WithClientsActions.resetWithClientsState, (state) => ({
      ...state,
      displayLayout: DisplayLayoutEnum.LIST,
      searchFields: undefined,
      data: undefined,
   })),
   on(WithClientsActions.getWithClientsDetailByID, (state) => ({
      ...state,
      withClientsDetail: undefined,
      isLoading: true,
   })),
   on(WithClientsActions.getWithClientsDetailByIDSuccess, (state, action) => ({
      ...state,
      withClientsDetail: action.data,
      isLoading: false,
   })),
   on(WithClientsActions.getWithClientsDetailByIDFailure, (state) => ({
      ...state,
      isLoading: false,
   }))
)
